class ModalWindow extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
        this.content = this.querySelector('.modal-window__content');
        this.newContent = this.content.cloneNode(true);
        this.modalWindow = document.querySelector('.modal-window');
        this.modalButton = this.querySelector('.modal-window__button')

        if(this.content && this.modalWindow){
            this.newContent.removeAttribute('hidden');
            this.modalWindow.appendChild(this.newContent);
        }

        this.modalButton.addEventListener('click', () => {
            this.modalWindow.setAttribute('open', '')
        })

        this.modalWindow.addEventListener('click', (e) => {
            if(e.target === this.modalWindow) this.modalWindow.removeAttribute('open')
        })

    }
  }
  
  // Define the custom element
  customElements.define('modal-window', ModalWindow);
  